import ReactGA from 'react-ga4';
export const initialize = () => {
    process.env.REACT_APP_GOOGLE_ANALYTICS &&
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);
};

export const event = ({ action, params = {}, user = {} }: any) => {
    user?.username && ReactGA.set({ dimension1: user?.username });
    user?.display_name && ReactGA.set({ dimension2: user?.display_name });
    user?.base_currency && ReactGA.set({ dimension3: user?.base_currency });
    user?.role && ReactGA.set({ dimension4: user?.role });
    user?.user_type && ReactGA.set({ dimension5: user?.user_type });
    user?.id && ReactGA.set({ dimension6: user?.id });
    user?.logged_in_at && ReactGA.set({ dimension8: user?.logged_in_at });
    user?.user_type && ReactGA.set({ dimension9: user?.user_type });
    ReactGA.event({ action, category: action, ...params });
};

export const send = (params: any) => {
    ReactGA.send(params);
};
